import React from 'react'

function ArrowLeft(props: any) {
  
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="none" d="M15.8337 10H4.16699" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path fill="none" d="M10.0003 15.8334L4.16699 10.0001L10.0003 4.16675" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowLeft


